<template>
	<div>
		<Modal 
            :loading="loading" 
            :title="current != 'new' ? 'EDITAR CLIENTE' : 'NOVO CLIENTE'"
            @close="close"
            @save="save"
        >
            <div class="row">
				<div class="col-xs">
					<small><b>Informações da empresa</b></small>
				</div>
			</div>
			<div v-if="current == 'new'" class="row">
				<div class="col-xs-12">
					<FormSelect v-model="fk_company" label="Empresa" :options="options_companies" :required="true" @input="setCompany" tooltip="Selecione empresa a qual o cliente pertence" ref="fk_company" />
				</div>
			</div>
			<div v-else class="row">
				<div v-if="(company_document != '') ? true : false" class="col-xs-4">
					<FormInputMasked v-model="company_document" label="CPF/CNPJ" type="tel" :required="false" :disabled="true" :mask="['###.###.###-##', '##.###.###/####-##']" tooltip="Documento da empresa a qual o cliente pertence" ref="company_document" />
				</div>
				<div v-if="(company_name != '') ? true : false" class="col-xs-8">
					<FormInput v-model="company_name" label="Nome" type="text" :required="false" :disabled="true" tooltip="Nome da empresa a qual o cliente pertence" ref="company_name" />
				</div>
            </div>
            <div class="row">
				<div class="col-xs">
					<small><b>Informações gerais</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12" :class="client_atak ? 'col-lg-6' : 'col-lg-12'">
					<FormInputMasked v-model="document" label="CPF/CNPJ" type="tel" :required="true" :mask="['###.###.###-##', '##.###.###/####-##']" :disabled="current != 'new' ? true : false" tooltip="Informe o documento de identificação do cliente" ref="document" />
				</div>
                <div v-if="client_atak" class="col-xs-12 col-lg-6">
					<FormInput v-model="code" label="Código do cliente" type="tel" :required="false" tooltip="Informe o código do cliente ('chave de fato' do registro do cliente no sistema integrado)" ref="code" />
				</div>
            </div>
            <div class="row">
				<div class="col-xs-12 col-lg-12">
					<FormInput v-model="name" label="Nome" type="text" :required="true" tooltip="Informe o nome do cliente" ref="name" />
				</div>
			</div>
            <div class="row">
				<div class="col-xs">
					<small><b>Informações de endereço</b></small>
				</div>
			</div>
			<form-group-address
				:current_id="id"
				:current_postal_code="postal_code"
				:current_street="street"
				:current_number="number"
				:current_complement="complement"
				:current_neighborhood="neighborhood"
				:current_city="city"
				:current_uf="uf"
				:current_country="country"
				:current_coordinates="coordinates"
				ref="formGroup"
			>
			</form-group-address>
			<div class="row">
				<div class="col-xs">
					<small><b>Informações de contato</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-4">
                    <FormInputMasked v-model="phone" label="Telefone" type="tel" :required="false" mask="+## ## #####-####" tooltip="Informe o número de telefone para contato" ref="phone" />
				</div>
				<div class="col-xs-12 col-lg-4">
                    <FormInputMasked v-model="contact_mobile" label="Whatsapp" type="tel" :required="false" mask="+## ## #####-####" tooltip="Informe o número do Whatsapp para contato" ref="contact_mobile" />
				</div>
				<div class="col-xs-12 col-lg-4">
					<FormInput v-model="contact_email" label="E-mail" type="email" :required="false" tooltip="Informe o e-mail para contato" ref="contact_email" />
				</div>
			</div>
            <div class="row">
				<div class="col-xs">
					<small><b>Informações de roteirização</b></small>
				</div>
			</div>
            <div class="row">
                <div class="col-xs-12 col-lg-6">
                    <FormInputMasked type="tel" label="Tempo médio de descarregamento" v-model="average_discharge_time" :mask="['# min','## min','### min','#### min','##### min']" tooltip="Informe o tempo médio que leva para descarregar entregas neste cliente (seja por questão de espaço, localidade, horário, etc)" ref="average_discharge_time" />
                </div>
            </div>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormSelect from "@/components/FormSelect";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormGroupAddress from '@/components/FormGroupAddress.vue';

export default {
	name: "AdminCustomerForm",

	props: {
		current: {
			type: [Object, String],
			required: true,
		},
		list_companies: {
			type: Array,
			require: true,
		},
	},

	components: {
		Modal,
		FormSelect,
		FormInput,
		FormInputMasked,
		FormGroupAddress,
	},

	data: function() {
		if (this.current != "new") {
			return {
				loading: false,
                
                id: this.current.id,
                document: this.current.document,
                code: this.current.code ? this.current.code : "",
                name: this.current.name,
                postal_code: this.current.postal_code,
                street: this.current.street.toUpperCase(),
                number: this.current.number ? this.current.number : "",
                complement: this.current.complement ? this.current.complement : "",
                neighborhood: this.current.neighborhood.toUpperCase(),
                city: this.current.city.toUpperCase(),
                uf: this.current.uf.toUpperCase(),
                country: this.current.country.toUpperCase(),
                coordinates: {
                    lat: this.current.coordinates.split(",")[0],
                    lng: this.current.coordinates.split(",")[1],
                },
                average_discharge_time: this.current.average_discharge_time ? this.current.average_discharge_time : "",
                phone: this.current.phone ? this.current.phone : "",
                contact_mobile: this.current.contact_mobile ? this.current.contact_mobile : "",
                contact_email: this.current.contact_email ? this.current.contact_email : "",

                fk_company: this.current.fk_company,
                company_name: this.current.company_name,
                company_document: this.current.company_document,
                client_atak: this.current.client_atak,
			};
		}

		return {
			loading: false,
            
            id: "",
			document: "",
            code: "",
            name: "",
            postal_code: "",
            street: "",
            number: "",
            complement: "",
            neighborhood: "",
            city: "",
            uf: "",
            country: "BRASIL",
            coordinates: null,
            average_discharge_time: "",
            phone: "",
            contact_mobile: "",
            contact_email: "",

            fk_company: "",
			client_atak: "",
		};
	},

	computed: {
		/**
		 * Cria a lista de seleção das empresas cadastradas
		 */
		options_companies: function() {
			let r = {};
			this.list_companies.map(c => {
				r[c.id] =  c.name.toUpperCase() + " - " + (c.document.length > 11 ? c.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : c.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"));
			});
			return r;
		},
	},

	methods: {
		/**
		 * Define se a empresa selecionada é cliente atak
		 * @param {string} event id da empresa selecionada
		 */
		setCompany: function(event) {
			let company = this.list_companies.find((element) => element.id == event);
			if ((typeof company !== "undefined") && (company.client_atak)) {
				this.client_atak = true;
			} else {
				this.client_atak = false;
			}
		},
		
		/**
		 * Retorna menssagem de erro no campo determinado
		 * @param {string} input nome do campo
		 */
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },
		
		/**
		 * Verifica e valida inicialmente os campos
		 */
		validation: function() {
			// Inicia as informações necessárias
			let data = {
                id: "",
                document: "",
                code: "",
                name: "",
                postal_code: "",
                street: "",
                number: "",
                complement: "",
                neighborhood: "",
                city: "",
                uf: "",
                country: "BRASIL",
                coordinates: null,
                average_discharge_time: "",
                phone: "",
                contact_mobile: "",
                contact_email: "",

				fk_company: "",
				company_name: "",
				company_document: "",
				client_atak: "",
            };
			let error = false;
            
			// Define o id do cliente
            data.id = this.id;
			// Verifica a empresa que o cliente pertence
			if (this.fk_company == "") {
				this.$refs.fk_company.validate();
				this.$notification.error(this.message("EMPRESA"));
				error = true;
			} else {
				data.fk_company = this.fk_company;
			}
			// Verifica o documento do cliente
			if (this.document == "") {
				this.$refs.document.validate();
				this.$notification.error(this.message("CPF/CNPJ"));
				error = true;
			} else {
				data.document = this.document;
			}
            // Define a chave de fato do cliente no sistema atak
            data.code = this.code;
			// Verifica o nome do cliente
            if (this.name == "") {
				this.$refs.name.validate();
				this.$notification.error(this.message("NOME"));
				error = true;
			} else {
				data.name = this.name;
			}
			// Verifica o endereço
			let dataAddress = this.$refs.formGroup.validation();
			if (dataAddress) {
				data.postal_code = dataAddress.postal_code;
				data.street = dataAddress.street;
				data.number = dataAddress.number;
				data.complement = dataAddress.complement;
				data.neighborhood = dataAddress.neighborhood;
				data.city = dataAddress.city;
				data.uf = dataAddress.uf;
                data.country = dataAddress.country;
				data.coordinates = dataAddress.coordinates;
			} else {
				error = true;
			}
			// Define campos de contato
            data.phone = this.phone;
            data.contact_mobile = this.contact_mobile;
            data.contact_email = this.contact_email;
            // Define o tempo de descarregamento para local do cliente
            data.average_discharge_time = this.average_discharge_time;

			// Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
		},
		
		/**
		 * Envia para API e salva as informações no BD e XML
		 */
        save: async function() {
			// Verifica se é um registro a ser editado
			if (this.id) {
				let confirm = await this.$alert.confirm("Deseja mesmo EDITAR esse cliente?");
				if (!confirm) return;
			}
			
			// Valida os dados
			let data = this.validation();
			if (data == null) {
				return;
			}
			
			// Define os campos enviados
			let form = {};
			form.data = data;
			
			// Requisita a API
			this.loading = true;
			let result = null;
			try {
				result = await Api.post_admin("customer/save", form);
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível processar as informações.");
				this.loading = false;
				return;
			}
			this.loading = false;
            // Verifica o resultado
            if (result) {
				if (result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					this.$notification.success("Cliente cadastrado com sucesso.");
					this.close();
					this.$parent.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível processar as informações.");
				return;
			}
		},

		// Fecha o modal
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped>
.add-new-product {
	margin-top: 10px;
	border: none;
	background: #000;
	color: #d9d9d9;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
}

.remove-product {
	float: right;
	background-color: red;
	color: #fff;
	font-weight: 700;
	font-size: 12px;
	border: none;
	padding: 5px 15px;
}

.order-list-products {
	margin-bottom: 15px;
	border: 1px solid black;
}

.order-list-products-item {
	padding: 10px;
	border-top: 1px solid black;
	border-bottom: 1px solid black;
}

</style>